import * as React from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Modal,
} from "@mui/material";
import ModalHeader from "../../modals/ModalHeader";
import AuthContext from "../../store/AuthContext";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  height: "max-content",
  overflowY: "auto",
  p: 2,
};

const LogOutModal = ({ title, opendata,setPunchOut }) => {
  const [open, setOpen] = React.useState(false);
  const authCtx = React.useContext(AuthContext);
  const [request,setRequest]=React.useState(false)
  const user = authCtx.user;
 const [anchorEl, setAnchorEl] = React.useState(null);
 const navigate=useNavigate()
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    authCtx.logout();
    setAnchorEl(null);
    navigate("/");
  };

  const handlePunchout = () => {
   
    
    postJsonData(`${ApiEndpoints.OUT_ATTENDANCE}/${user.id}`,
{},
setRequest,
(res)=>{

},
(err=>{
  apiErrorToast(err)
})
    

    )
    
   
  };

  return (
    <Modal
      open={opendata}
      onClose={handleClose}
      aria-labelledby="logout-punchout-modal"
      disablePortal
      disableEnforceFocus
      disableAutoFocus
    >
      <Paper sx={style}>
      {user.role==="Developer"&&

        <ModalHeader title="Logout And Punchout" handleClose={()=>setPunchOut(false)} />
      }

<ModalHeader title="Logout" handleClose={()=>setPunchOut(false)} />


        {user.role==="Developer"&&

        <Typography variant="h6" sx={{ mb: 2 }}>
          Are you sure you want to logout or punchout, {user?.name || "Developer"}?
        </Typography>
}

<Typography variant="h6" sx={{ mb: 2 }}>
  Are you sure you want to logout {user?.name || "Developer"}?
</Typography>


        <Box display="flex" justifyContent="space-between" mt={2}>
          <Button variant="contained" color="error" onClick={handleLogout}>
            Logout
          </Button>
          {user.role==="Developer"&&
          <Button variant="contained" color="primary" onClick={handlePunchout}>
            Punchout
          </Button>
}
        </Box>
      </Paper>
    </Modal>
  );
};

export default LogOutModal;